import React from "react";
import SectionToDisplay from "../../../containers/sections/SectionToDisplay/SectionToDisplay";

interface ParagraphSectionProps {
	section: Queries.SectionDataFragment;
	forceFlatCards: boolean;
	isHomePage: boolean;
}

export const getParagraphSectionProps = (
	{ relationships: { field_section } }: Queries.ParagraphSectionDataFragment,
	forceFlatCards: boolean,
	isHomePage: boolean,
) => ({
	section: field_section,
	forceFlatCards,
	isHomePage,
});
export const ParagraphSection: React.FC<ParagraphSectionProps> = ({
	section,
	isHomePage,
}) => {
	return <SectionToDisplay section={section} isHomePage={isHomePage} />;
};
